export default __webpack_public_path__ + "static/media/bare-metal.0f6ec437.svg";